export default "<p>test works!</p>\n"